<template>
  <TableLayout :permissions="['business:member:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" >
      <el-form-item label="用户" prop="nickname">
        <el-input v-model="searchForm.nickname"  style="width: 160px" placeholder="昵称/手机号/真实姓名" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status"  >
        <el-select   v-model="searchForm.status" placeholder="状态"  clearable @change="search">
          <el-option :key="0" :value="0" label="启用"></el-option>
          <el-option :key="1" :value="1" label="禁用"></el-option>
          <el-option :key="2" :value="2" label="已注销"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联经销商" prop="shopName">
        <el-input v-model="searchForm.shopName"  style="width: 160px" placeholder="经销商名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
        <el-form-item label="创建时间" prop="starttime" >
          <el-date-picker
              style="width: 160px"
            v-model="searchForm.starttime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            placeholder="开始时间"
        ></el-date-picker>
        </el-form-item>
        <el-form-item label="-" label-width="10px" prop="endtime" >
          <el-date-picker
              style="width: 160px"
              v-model="searchForm.endtime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              placeholder="截止时间"
          ></el-date-picker>
        </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:member:exportExcel' ]">
        <li> <el-button type="primary" :loading="isWorking.export" v-permissions="['business:member:exportExcel']" @click="exportExcel">导出</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <el-table-column prop="nickname" label="昵称" fixed align="center"  min-width="100px">
          <template slot-scope="{row}">
            <span style="cursor: pointer" title="点击查看详情" class="blue" @click="showMemberDetail(row)">{{row.nickname}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="imgurl" label="头像" align="center" min-width="70px">
          <template slot-scope="{row}">
            <el-image style="width: 60px;height: 60px;"  v-if="row.imgurl" :src="row.imgFullUrl+row.imgurl" :preview-src-list="[row.imgFullUrl+row.imgurl]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="openId" label="微信openid" align="center"  min-width="150px"  >
          <template slot-scope="{row}">
            <span >{{row.openId}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="客户姓名" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="phone" label="授权手机号" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="idcard" label="身份证号" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="integral" label="现有积分" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="totalIntegral" label="累计积分" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="totalReduceIntegral" label="累计扣除" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="shopName" label="关联经销商" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center"  min-width="140px"></el-table-column>
        <el-table-column label="状态" align="center"  min-width="100px">
          <template slot-scope="{row}">
            <el-switch v-if="row.status !=2"
              v-model="row.status"
              active-color="#13ce66"
              inactive-color="#999"
              :active-value="0"
              :inactive-value="1"
              @change="statusChange(row)"
            ></el-switch>
            <span v-if="row.status==2" class="grey">已注销</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center"  min-width="100px">
          <template slot-scope="{row}">
            <el-button type="text" @click="showMemberDetail(row)">详情</el-button>
            <el-button type="text" v-if="row.bindShopId !=null && row.status!=2" @click="changeShop(row)">更换经销商</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
      <OperaChangeShopWindow ref="OperaChangeShopWindow" @success="handlePageChange" />
      <OperaMemberDetail ref="operaMemberDetail" @success="handlePageChange"/>
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaMemberDetail from '@/components/business/OperaMemberDetail'
import OperaChangeShopWindow from '@/components/business/OperaChangeShopWindow'
import { updateById } from '@/api/business/member'
export default {
  name: 'Member',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaMemberDetail ,OperaChangeShopWindow},
  data () {
    return {
      // 搜索
      searchForm: {
        starttime: null,
        endtime: null,
        status: null,
        nickname: '',
        shopName: ''
      }
    }
  },
  created () {
    this.config({
      module: '用户信息表',
      api: '/business/member',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    changeShop(row){
      this.$refs.OperaChangeShopWindow.open('更换经销商',row)
    },
    statusChange(row) {
      console.log(row);
      updateById(row)
        .then(() => {
          this.$tip.success('修改成功')
        })
        .catch(e => {
          this.$tip.error(e)
        })
        .finally(() => {
          this.handlePageChange()
        })
    },
    showMemberDetail(row) {
      this.$refs.operaMemberDetail.open('会员详情', row)
    }
  }
}
</script>

<style scoped>
/*::v-deep .el-input{
  width: 200px;
}*/
</style>
